export default __webpack_public_path__ + "achievement.593d03db2a690d9f803daec4542577c0.svg";